export default class Util {
  static uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  } //uuid4

  static isUUID( uuid ){
    let ret = uuid.match( /([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})/ );
    // console.log('isUUID:', ret );
    return (ret != undefined && ret.length == 2); //match has one match
  }

  static retobj( successTF, message ){ //a convenience return object
    return {success: successTF, message: message};
  }

}


